/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upgrade_PlanInputs */

const en_upgrade_plan = /** @type {(inputs: Upgrade_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade Plan`)
};

const es_upgrade_plan = /** @type {(inputs: Upgrade_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar plan`)
};

const fr_upgrade_plan = /** @type {(inputs: Upgrade_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre à niveau le forfait`)
};

const de_upgrade_plan = /** @type {(inputs: Upgrade_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan upgraden`)
};

const ja_upgrade_plan = /** @type {(inputs: Upgrade_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プランをアップグレード`)
};

const zh_upgrade_plan = /** @type {(inputs: Upgrade_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`升级套餐`)
};

const ar_upgrade_plan = /** @type {(inputs: Upgrade_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ترقية الخطة`)
};

const id_upgrade_plan = /** @type {(inputs: Upgrade_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tingkatkan Paket`)
};

const it_upgrade_plan = /** @type {(inputs: Upgrade_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna Piano`)
};

const ru_upgrade_plan = /** @type {(inputs: Upgrade_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновить тариф`)
};

const pt_upgrade_plan = /** @type {(inputs: Upgrade_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fazer Upgrade do Plano`)
};

const ko_upgrade_plan = /** @type {(inputs: Upgrade_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`요금제 업그레이드`)
};

/**
* | output |
* | --- |
* | "Upgrade Plan" |
*
* @param {Upgrade_PlanInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const upgrade_plan = /** @type {((inputs?: Upgrade_PlanInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upgrade_PlanInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_upgrade_plan(inputs)
	if (locale === "es") return es_upgrade_plan(inputs)
	if (locale === "fr") return fr_upgrade_plan(inputs)
	if (locale === "de") return de_upgrade_plan(inputs)
	if (locale === "ja") return ja_upgrade_plan(inputs)
	if (locale === "zh") return zh_upgrade_plan(inputs)
	if (locale === "ar") return ar_upgrade_plan(inputs)
	if (locale === "id") return id_upgrade_plan(inputs)
	if (locale === "it") return it_upgrade_plan(inputs)
	if (locale === "ru") return ru_upgrade_plan(inputs)
	if (locale === "pt") return pt_upgrade_plan(inputs)
	return ko_upgrade_plan(inputs)
});